import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import router from '../router/index';
import createPersistedState from "vuex-persistedstate";
import _ from 'lodash';
import { setTimeout } from 'core-js';
const config = require("../assets/conf-example.json");
// import skin from '../../../main_config/skin.json'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    infoRouter: null,
    colBanks: [],
    paymentQuickly_form: {},
    payment_quicklypay: {},
    payment_quicklypayout: {},
    currency: { fiat: '', rate: 1 },
    coin_info: {},
    coin_info2: {},
    payment_data: {},
    payment_criptopay:{},
    payment_data_rate: {},
    payment_form: {},
    payment88_form: {},
    paymentPix_form: {},
    payment_form_rate: {},
    withdraw_data: {},
    withdraw_criptopay:{},
    withdraw_data_pix: {},
    payment_88pay: {},
    payment_pixpay: {},
    withdraw_form: {},
    language: "en",
    currentSkin: 0,
    skins: [{}],
    hostName: '',
    skin_charged: false,
    translation: {},
    user_token: "",
    user_token_demo: "",
    site_id: "",
    site: "",
    jivoElement1: null,
    domain: "",
    prefix: "api",
    user_data: {},
    user_data_demo: {},
    user_data_history: {},
    view: 'main',
    lobby_view: "main",
    rechargeIframe: 0,
    headerHeight: 0,
    showChangePassword: false,
    actualRoute: "",
    productsAccess: {},
    widget_load: false,
    jivo_modal_flag: false,
    message_recived: false,
    home_button: false,
    mis_datos: false,
    apiHostnew: '',
    auditoria: {},
    qtag: '',
    afiliado: {},
    root: {},
    root2: {},
    config: config,
    // conv:[],
    // socket: ""
  },
  plugins: [createPersistedState({
    paths: ['skins', 'user_data', 'site', 'domain', 'prefix', 'site_id', 'hostName', 'user_token', 'site']
  })],
  mutations: {
    set_urls(state) {
      if (!state.user_data || !state.skins?.[0]?.categories) return;

      const mappings = [
        { category: "sport", key: "sports", key1: "prematch" },
        { category: "sportlive", key: "sports", key1: "prematch" },
        { category: "casino", key: "casino", key1: "slots" },
        { category: "casinolive", key: "casinolive", key1: "live_casino" },
        { category: "hipicas", key: "hipicas", key1: "horse" }
      ];

      mappings.forEach(({ category, key, key1 }) => {
        let categoryIndex = state.skins[0].categories.findIndex(cat => cat.category === category);

        if (categoryIndex !== -1) { // Si encontró la categoría
          let informo;
          if (state.skins[0].skin_type !== 'altenar') {
            informo = state.user_data.products?.[key];
          } else {
            informo = state.user_data?.data?.products?.[key1];
          }

          // Solo modificar si informo tiene un valor válido
          if (informo !== undefined) {
            state.skins[0].categories[categoryIndex].active = informo;
          }
        }
      });
    },

    set_config(state, payload) {
      state.config = payload;
    },
    setInfoRouter(state, info) {
      state.infoRouter = info;
    },
    setQuicklyPayBanks(state, payload) {
      state.colBanks = payload
    },
    setQuicklyPay(state, payload) {
      state.payment_quicklypay = payload
      // console.log(state.payment_data)
    },
    setQuicklyPayOut(state, payload) {
      state.payment_quicklypayout = payload
      // console.log(state.payment_data)
    },
    get88Payment(state, payload) {
      state.payment88_form = payload
      // console.log(state.payment88_form)
    },
    getPixPayment(state, payload) {
      state.paymentPix_form = payload
      // console.log(state.payment88_form)
    },
    getQuicklyPayment(state, payload) {
      state.paymentQuickly_form = payload
      // console.log(state.payment88_form)
    },
    getPayment(state, payload) {
      state.payment_form = payload
      // console.log(state.payment_form)
    },
    getPayment2(state, payload) {
      state.payment_form_rate = payload
      // console.log(state.payment_form)
    },
    getWithdraw(state, payload) {
      state.withdraw_form = payload
      // console.log(state.withdraw_form)
    },
    setPayment(state, payload) {
      state.payment_data = payload
      // console.log(state.payment_data)
    },
    set88pay(state, payload) {
      state.payment_88pay = payload
      // console.log(state.payment_data)
    },
    setPixpay(state, payload) {
      state.payment_pixpay = payload
      // console.log(state.payment_pixpay)
    },
    setCriptopay(state, payload) {
      state.payment_criptopay = payload
      console.log(state.payment_criptopay)
    },
    setCriptopayOut(state, payload) {
      state.withdraw_criptopay = payload
      console.log(state.withdraw_criptopay)
    },
    setPixdata(state, payload) {
      state.payment_pixpay.fields = payload.data
      state.payment_pixpay.amount = payload.amount
      // console.log(state.payment_pixpay,state.domain)
    },
    setCriptodata(state, payload) {
      state.payment_criptopay.kyc = payload.data
      state.payment_criptopay.totalPrice = payload.amount
      state.payment_criptopay.lineItems[0].price = payload.amount
      // console.log(state.payment_pixpay,state.domain)
    },
    setCriptodataWD(state, payload) {
      state.withdraw_criptopay.destinationAccount.destinationType = payload.data
      state.withdraw_criptopay.amount = payload.amount
      // console.log(state.payment_pixpay,state.domain)
    },
    setQuicklydata(state, payload) {
      state.payment_quicklypay.usuDoc = payload.usuDoc
      state.payment_quicklypay.usuCorreo = payload.usuCorreo
      state.payment_quicklypay.usuNombre = payload.usuNombre
      state.payment_quicklypay.usuTipdoc = payload.usuTipdoc
      state.payment_quicklypay.usuTelefono = payload.usuTelefono
      state.payment_quicklypay.bank = payload.bank
      state.payment_quicklypay.valor = payload.valor
      // console.log(state.payment_pixpay,state.domain)
    },
    setQuicklydataWD(state, payload) {
      state.payment_quicklypayout.usuDoc = payload.usuDoc
      state.payment_quicklypayout.usuCorreo = payload.usuCorreo
      state.payment_quicklypayout.usuNombre = payload.usuNombre
      state.payment_quicklypayout.usuTipdoc = payload.usuTipdoc
      state.payment_quicklypayout.usuTelefono = payload.usuTelefono
      state.payment_quicklypayout.tipoCuenta = payload.tipoCuenta
      state.payment_quicklypayout.numCuenta = payload.numCuenta
      state.payment_quicklypayout.bank = payload.bank
      state.payment_quicklypayout.valor = payload.valor
      // console.log(state.payment_quicklypayout)
    },
    setPayment2(state, payload) {
      state.payment_data_rate = payload
      // console.log(state.payment_data_rate)
    },
    setWithdraw(state, payload) {
      state.withdraw_data = payload
      // console.log(state.payment_data)
    },
    setWithdrawPix(state, payload) {
      state.withdraw_data_pix = payload
      // console.log(state.withdraw_data_pix)
    },
    set88paydata(state, payload) {
      state.payment_88pay.cardCVV = payload.cardCVV
      state.payment_88pay.cardYear = payload.cardYear
      state.payment_88pay.cardMonth = payload.cardMonth
      state.payment_88pay.cardNumber = payload.cardNumber
      state.payment_88pay.customer.name = payload.cardName
      state.payment_88pay.email = payload.cardEmail
      state.payment_88pay.cardYear = payload.cardYear
      state.payment_88pay.paymentMethod = payload.paymentMethod
      state.payment_88pay.country = payload.country
      state.payment_88pay.amount = (payload.amount).toString()
      // console.log(state.payment_88pay)
    },
    setCurrency(state, payload) {
      state.payment_data.Currency = payload.payload.Currency
      state.payment_data.DestinationTag = payload.payload.DestinationTag
      state.coin_info = payload.coin_info
      // console.log(state.payment_data,state.coin_info)
    },
    setCurrency2(state, payload) {
      state.payment_data_rate.Currency = payload.payload.Currency
      state.payment_data_rate.DestinationTag = payload.payload.DestinationTag
      state.coin_info2 = payload.coin_info
      state.coin_info2.rate = payload.result
      // console.log(state.payment_data_rate,state.coin_info2)
    },
    setAmount(state, payload) {
      state.withdraw_data.Currency = payload.Currency
      state.withdraw_data.DestinationTag = payload.DestinationTag
      state.withdraw_data.Amount = payload.Amount
      state.withdraw_data.AmountUSD = payload.AmountUSD
      state.withdraw_data.Address = payload.Address
      // console.log(state.withdraw_data)
    },
    setAmountPix(state, payload) {
      state.withdraw_data_pix.amount = payload.amount
      state.withdraw_data_pix.fields = payload.data
      // console.log(state.withdraw_data_pix)
    },
    setAfiliado(state, payload) {
      state.afiliado = payload
      // console.log(state.afiliado)
    },
    setRoot(state, payload) {
      state.root = payload
      // console.log(state.root)
    },
    setRoot2(state, payload) {
      state.root2 = payload
      // console.log(state.root)
    },
    setQtag(state, payload) {
      // console.log(payload)
      state.qtag = payload
    },
    SET_JIVO_ELEMENT1(state, payload) {
      state.jivoElement1 = payload;
    },
    setActualRoute(state, payload) {
      state.actualRoute = payload
    },
    setShowChangePassword(state, payload) {
      state.showChangePassword = payload
    },
    setHeaderHeight(state, payload) { state.headerHeight = payload },
    changeCurrencyFiat(state, payload) {
      state.currency.fiat = payload.fiat;
      state.currency.rate = payload.rate;
    },
    setHostName(state, payload) {
      state.hostName = payload;
    },
    setRechargeIframe(state) {
      state.rechargeIframe++
    },
    setCurrentSkin(state, payload) {
      state.currentSkin = payload;
    },
    setApiHostnew(state, payload) {
      state.apiHostnew = payload;
    },
    clearUserDataHistory(state, payload) {
      jivo_api.clearHistory();
      state.user_data_history = {};
      console.log('Widget is deleted')
    },
    setUserData(state, payload) {
      // console.log(payload)
      state.user_data = payload;
      // console.log( state.user_data)
      if (Object.keys(state.user_data_history).length === 0 && state.user_data_history.constructor === Object) {
        state.user_data_history = payload;
      }
    },
    setUserData2(state, payload) {
      // console.log(payload)
      state.user_data_demo = payload;
    },
    setCustomData(state, payload) {
      if (state.user_token != '') {
        state.widget_load = true
        jivo_api.setCustomData([
          {
            "content": "User Name: " + payload.data.user_name,
          },
          {
            "content": "User id: " + payload.data.user_id,
          },
          {
            "content": "Rol: " + payload.data.rol,
          },
          {
            "content": "Balance: " + payload.data.balance,
          },
          {
            "content": "Currency: " + payload.data.currency,
          },
          {
            "content": "Site: " + state.hostName,
          },
        ])
      }
    },
    setLanguage(state, payload) {
      state.language = payload;
      let rerender = setTimeout(function () {
        clearTimeout(rerender);
      }, 300)
    },
    detach(state, payload) {
      state.skins = payload;
    },
    UserData(state, payload) {
      state.user_data = payload;
    },
    setToken(state, payload) {
      state.user_token = payload.token;
      state.site_id = payload.site_id;
      state.site = payload.site;
      state.prefix = payload.prefix;
    },
    setToken2(state, payload) {
      state.user_token_demo = payload.token;
      state.site_id = payload.site_id;
      state.site = payload.site;
      state.prefix = payload.prefix;
    },
    setTranslations(state, payload) {
      state.translation = payload;
    },
    setDomain(state, payload) {
      state.domain = payload;
    },
    setView(state, payload) {
      state.view = payload;
    },
    setJivo_modal_flag(state, payload) {
      state.jivo_modal_flag = payload;
    },
    setMainView(state, payload) {
      state.skins = payload;
      state.language = payload[0].default_language;
      state.skin_charged = true;
    },
    setLobbyView(state, payload) {
      state.lobby_view = payload;
    },
    setHomeButton(state, payload) {
      state.home_button = payload;
    },
    logOut(state) {
      state.user_data = {},
        state.user_token = "";
      state.prefix = "api";

      state.jivo_modal_flag = false
      state.widget_load = false

    },
    setMessage(state, payload) {
      state.message_recived = payload;
    },
    setWidget(state, payload) {
      state.widget_load = payload;
    },
    setMisdatos(state, payload) {
      state.mis_datos = payload;
    },
    setAuditoria(state, payload) {
      state.auditoria = payload;
    }
  },
  actions: {
    changeView({ state, commit, dispatch }, view) {
      // Validar que state.skins[0]?.categories existe y es un array
      const categories = Array.isArray(state.skins[0]?.categories)
        ? state.skins[0].categories.filter(cat => cat.active)
        : [];
    
      if (!categories.length) return;
    
      let infoRouter = null;
    
      // 🔹 Manejo del caso "openCasinoGameFromLobby"
      if (view?.data?.view === "openCasinoGameFromLobby") {
        console.log("openCasinoGameFromLobby import");
        infoRouter = categories.find(cat => cat.category === "casino");
    
        if (infoRouter) {
          infoRouter.id = view.data.data;
          commit("setInfoRouter", infoRouter);
          dispatch("setRechargeIframe");
        }
        return;
      }
    
      // 🔹 Manejo de `view` como índice o string
      if (typeof view === "number") {
        infoRouter = categories[view] || null;
        console.log("view as index", infoRouter);
      } else if (typeof view === "string") {
        infoRouter = categories.find(cat => cat.category === view) || null;
      }
    
      if (!infoRouter) return;
    
      // 🔹 Validación de acceso si el usuario no ha iniciado sesión
      const restrictedCategories = ["casino_live", "casino", "hipicas", "poker", "crazzywin", "esport"];
    
      if (restrictedCategories.includes(infoRouter.category) && !state.user_token) {
        document.getElementById("login_btn").click();
        return;
      }
    
      // 🔹 Verificar si la categoría está activa antes de continuar
      if (infoRouter.active) {
        commit("setInfoRouter", infoRouter);
        dispatch("setRechargeIframe");
      }
    },
    async getUserData(state, payload) {
      try {
        const response2 = await axios.post(
          (state.state.domain || payload.domain) +
          "/" +
          state.state.prefix +
          "/scommand?access_token=" +
          payload.token +
          "&unico=" +
          payload.token +
          "&site=" +
          payload.site,
          { command: "get_balance", params: {} }
        );
        if (response2.data.data.error) {
          state.commit("setToken", {
            token: "",
            site_id: payload.site_id,
            site: payload.site,
            prefix: payload.prefix,
          });
          swal("Error", response2.data.data.message, "error");
        } else {
          state.commit("setUserData", response2.data);
          if (localStorage.getItem("bet_currency")) {
            let newVal = localStorage.getItem("bet_currency");
            state.commit("changeCurrencyFiat", {
              fiat: newVal,
              rate:
                newVal != "BETC"
                  ? newVal == "USDT"
                    ? response2.data.data.tasa
                    : response2.data.data.tasa_fiat
                  : 1,
            });
          } else {
            state.commit("changeCurrencyFiat", {
              fiat: response2.data.data.currency_fiat,
              rate: response2.data.data.tasa_fiat,
            });
            localStorage.setItem(
              "bet_currency",
              response2.data.data.currency_fiat
            );
          }
        }
      } catch (error) {
        state.commit("setToken", {
          token: "",
          site_id: payload.site_id,
          site: payload.site,
          prefix: payload.prefix,
        });
      }
    },
    async setMisdatos(state, payload) {
      state.commit("setMisdatos", payload)
    },
    async setCurrency(state, payload) {
      let data = await axios.get('https://app.0xprocessing.com/Api/CoinInfo/' + payload.Currency, {
        headers: {
          'APIKEY': 't4@#0zF@KSBhiS9W5lPId8F9TU@xK5GeeK2Mmc1ST40GeNDkoK0R0Ogr9j#pmEQ97L2!tq36BKtj3QK@qoZD7W_T!jc@cWGe6i4!f_5tt8cmhlw43##pBgr#nk7SdXxmN8BLQ8U#8pSO5qcGYIvwcTFLtWQrajz@pd!87HT$bkLSbwy2kc@30s60Dz@bkb9g3w6esiWz6WOk8dnNAhMbWdaikgFjL74P8hIM4PETPkX4Zmk1CavhXn_ykP' // Reemplaza con tu API Key
        }
      })
      state.commit("setCurrency", { payload, coin_info: data.data })
    },
    async set88paydata(state, payload) {
      state.commit("set88paydata", payload)
    },
    async setPixdata(state, payload) {
      state.commit("setPixdata", payload)
    },
    async setCriptodata(state, payload) {
      state.commit("setCriptodata", payload)
    },
    async setCriptodataWD(state, payload) {
      state.commit("setCriptodataWD", payload)
    },
    async setQuicklydata(state, payload) {
      state.commit("setQuicklydata", payload)
    },
    async setQuicklydataWD(state, payload) {
      state.commit("setQuicklydataWD", payload)
    },
    async setCurrency2(state, payload) {
      try {
        await state.commit("setCurrency2", { payload, coin_info: {}, result: '' })
        // state.dispatch("getPayment2");
        let data = await axios.get('https://app.0xprocessing.com/Api/CoinInfo/' + payload.Currency, {
          headers: {
            'APIKEY': 't4@#0zF@KSBhiS9W5lPId8F9TU@xK5GeeK2Mmc1ST40GeNDkoK0R0Ogr9j#pmEQ97L2!tq36BKtj3QK@qoZD7W_T!jc@cWGe6i4!f_5tt8cmhlw43##pBgr#nk7SdXxmN8BLQ8U#8pSO5qcGYIvwcTFLtWQrajz@pd!87HT$bkLSbwy2kc@30s60Dz@bkb9g3w6esiWz6WOk8dnNAhMbWdaikgFjL74P8hIM4PETPkX4Zmk1CavhXn_ykP' // Reemplaza con tu API Key
          }
        })
        let data2 = await axios.get('https://app.0xprocessing.com/Api/ConvertToCrypto', { params: { OutCurrency: payload.Currency, InCurrency: state.state.user_data.data.currency, InAmount: payload.Amount } })
        await state.commit("setCurrency2", { payload, coin_info: data.data, result: data2.data.result })

        // console.log(data.data)
      } catch (error) {
        console.log(error)
      }
    },
    async setAmount(state, payload) {
      state.commit("setAmount", payload)
    },
    async setAmountPix(state, payload) {
      state.commit("setAmountPix", payload)
    },
    async setActualRoute(state, payload) {
      state.commit("setActualRoute", payload)
    },
    async setJivo_modal_flag(state, payload) {
      state.commit("setJivo_modal_flag", payload)
    },
    async setHeaderHeight(state, payload) {
      state.commit("setHeaderHeight", payload);
    },
    async setRechargeIframe(state) {
      state.commit("setRechargeIframe");
    },
    async changeCurrencyFiat(state, payload) {
      await state.commit("changeCurrencyFiat", payload);
    },
    async setView(state, payload) {
      await state.commit("setView", payload)
    },
    async setMainView(state) {
      await state.commit("setMainView")
    },
    async setCurrentSkin(state, payload) {
      await state.commit("setCurrentSkin", payload)
    },
    async setLanguage(state, payload) {
      await state.commit("setLanguage", payload)
      state.dispatch("setRechargeIframe")
    },
    async setMessage(state, payload) {
      await state.commit("setMessage", payload)
    },
    async detach_data(state, payload) {
      await state.commit("detach", payload)
    },
    async getProfile(state, payload) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_DATA_SERVER}front_profile?token=${payload.token}${payload.site_id}-${payload.site}&playerId=${payload.playerId}`)
        if (response.data.data) {
          state.commit("setUserData", response.data);
        }
        if (!payload.source) {
          let formated = router.currentRoute.query.target;
          if (formated.includes("-")) {
            if (formated.split("-")[2] == 'owned') {
              state.dispatch("getAuditoria", { data: response.data })
            }
          }
        }
        state.commit("setUserData", response.data);
        if (Object.keys(state.state.auditoria ?? {}).length == 0) {
          state.dispatch("getAuditoria", { data: response.data })
        }
        if (state.state.widget_load) {
          state.dispatch("getCustomData");
          state.commit('setWidget', false)
        }
      } catch (error) {
        // localStorage.setItem('errorfront_profile', error);
        // localStorage.removeItem("user_data");
        // state.commit("setToken", {
        //   token: "",
        //   site_id: payload.site_id,
        //   site: payload.site,
        //   prefix: payload.prefix
        // });
        if (error.response && error.response?.status === 401) {
          state.commit("setToken", {
            token: "",
            site_id: payload.site_id,
            site: payload.site,
            prefix: payload.prefix
          });
          state.dispatch("logOut");
          return 'error'
        }
        else {
          console.log(error.response?.status, error)
        }
      }
    },
    async getProfile2(state, payload) {
      try {
        const response = await axios.get(`${process.env.VUE_APP_DATA_SERVER}front_profile?token=${payload.token}${payload.site_id}-${payload.site}&playerId=${payload.playerId}`)
        if (response.data.data) {
          state.commit("setUserData2", response.data);
        }
      } catch (error) {
        // localStorage.setItem('errorfront_profile2', error);
        // localStorage.removeItem("user_data");
        // state.commit("setToken", {
        //   token: "",
        //   site_id: payload.site_id,
        //   site: payload.site,
        //   prefix: payload.prefix
        // });
        if (error.response && error.response?.status === 401) {
          state.commit("setToken", {
            token: "",
            site_id: payload.site_id,
            site: payload.site,
            prefix: payload.prefix
          });
          state.dispatch("logOut");
          return 'error'
        }
        else {
          console.log(error.response?.status, error)
        }
      }
    },
    async getSiteDomain(state, payload) {
      try {
        const response = await axios.get(
          process.env.VUE_APP_DATA_SERVER + "get_domain?site_id=" + payload.site_id
        );
        let domain = response.data.domain;
        payload.domain = domain;
        state.commit("setDomain", domain);
        if (!payload.type) {
          state.dispatch("getConfig", domain);
        }
        let apiHostnew = `https://local-admin.${domain.split('//')[1].split('admin.')[1]}/`;
        localStorage.setItem("setApiHostnew", apiHostnew)
        state.commit("setApiHostnew", apiHostnew);
        if (state.state.qtag != '') {
          state.dispatch('getAffiliate', state.state.qtag)
        } else {
          state.dispatch('getPanel')
        }
        payload.type = null;
        if (state.state.skins[0].skin_type === 'altenar') {
          if (state.state.user_token != "" && state.state.site_id != 86174) {
            state.dispatch("getUserData", payload);
          }
          state.commit("setDomain", domain);
          payload.type = null;
        }
        localStorage.setItem("user_data", JSON.stringify(payload));
        // console.log(state.state.skins[0].demo_user)
        if(state.state.skins[0].demo_user?.enabled){
          state.dispatch('login_demo', {username:state.state.skins[0].demo_user.user, password:state.state.skins[0].demo_user.password})
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getConfig(state, payload) {
      let rid = Date.now();
      try {
        const response = await axios.get(
          payload +
          "/setup/" +
          state.getters.getUserData.site +
          "/conf.json?" +
          rid
        );
        state.commit("set_config", response.data);
      } catch (error) {
        console.log(error);
        const response = await axios.get(payload + "/setup/conf.json?" + rid);
        state.commit("set_config", response.data);
      }
    },
    async getPanel(state) {
      // console.log(state.state.skins[0].register_fields.root)
      let login_Id = state.state.skins[0].register_fields.root;
      const url = state.state.apiHostnew;
      if (typeof login_Id === 'object' && login_Id !== null) {
        // Si es un objeto, obtener info para cada id y guardar en setRoot y setRoot2
        const ids = Object.values(login_Id);
        if (ids.length > 0) {
          // Primer id para setRoot
          const response1 = await axios.get(url + "informacion", { params: { users: ids[0], login_Id: ids[0], token: 'qCpxTbvkZBePznR', site: state.state.site_id } });
          if (response1.data) {
        state.commit('setRoot', response1.data);
          }
          // Segundo id para setRoot2 (si existe)
          if (ids[1]) {
        const response2 = await axios.get(url + "informacion", { params: { users: ids[1], login_Id: ids[1], token: 'qCpxTbvkZBePznR', site: state.state.site_id } });
        if (response2.data) {
          state.commit('setRoot2', response2.data);
        }
          }
        }
        // No continuar con el resto del método
        return;
      }
      const response = await axios.get(url + "informacion", { params: { users: login_Id, login_Id: login_Id, token: 'qCpxTbvkZBePznR', site: state.state.site_id } });
      // console.log(response.data)
      if (response.data) {
        state.commit('setRoot', response.data)
      }
    },
    async setToken(state) {
      let site = "";
      let site_id = "";
      let token = "";
      let prefix = "api";
      let formated = router.currentRoute.query.target;
      if (formated.includes("-")) {
        if (formated.split("-")[2] == 'integration') {
          site = formated.split("-")[0];
          site_id = formated.split("-")[1];
          prefix = 'external';
          if (router.currentRoute.query.token) {
            if (router.currentRoute.query.token != "") {
              token = router.currentRoute.query.token;
            }
          }
        }
        else if (formated.split("-")[2] == 'owned') {
          site_id = formated.split("-")[1];
          site = "jugar";
          if (router.currentRoute.query.token) {
            if (router.currentRoute.query.token != "") {
              token = router.currentRoute.query.token.slice(0, -5);
            }
          }
        }
      }
      else {
        site = "jugar";
        if (router.currentRoute.query.token) {
          if (router.currentRoute.query.token != "") {
            token = router.currentRoute.query.token.slice(0, -5);
            site_id = router.currentRoute.query.token.substring(token.length, router.currentRoute.query.token.length)
          }
        }
      }
      let router_data = {
        token: state.state.user_token,
        site_id: site_id,
        site: site,
        prefix: prefix
      }
      state.commit("setToken", router_data);
      state.dispatch("getSiteDomain", router_data);
    },
    async getWidget(state) {
      const jivoScript = document.createElement('script');
      jivoScript.src = "//code.jivosite.com/widget/" + router.currentRoute.query.supportId;
      jivoScript.async = true;
      document.head.appendChild(jivoScript);
    },

    getCustomData(state) {
      const userDataWithoutToken = _.omit(state.state.user_data, ['data.token']);
      const userDataHistoryWithoutToken = _.omit(state.state.user_data_history, ['data.token']);
      if (_.isEqual(userDataWithoutToken, userDataHistoryWithoutToken)) {
        // console.log('No hay diferencias, no se hace nada.');
        state.commit("setCustomData", state.state.user_data);
      } else {
        // console.log('hay diferencias');
        state.commit("clearUserDataHistory")
        state.commit("setWidget", false)
        setTimeout(() => {
          state.commit("setUserData", state.state.user_data);
          state.dispatch("getWidget");
        }, 500);
      }
    },
    setHomeButton(state, payload) {
      // console.log('setHomeButton')
      state.commit('setHomeButton', payload)
    },
    async setPayment(state) {
      // console.log(state.state.user_data,state.state.user_token,state.state.skins[0].auto_payment.provider)
      let domain = state.state.domain
      // console.log(`https://${domain.split('//')[1].split('admin.')[1]}/`)
      if (state.state.skins[0].auto_payment) {
        if (state.state.skins[0].auto_payment.providers[0].name == '0xProcessing' && state.state.skins[0].auto_payment.providers[0].enabled) {
          // console.log(state.state.user_data.data)
          let ClientId = state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id
          let FirstName = state.state.user_data.data.user_name
          let LastName = ''
          let DestinationTag = ''
          let BillingID = state.state.user_data.data.user_id + '_' + state.state.site_id
          let MerchantID = state.state.skins[0].auto_payment.config.MerchantID
          let Email = state.state.user_data.data.email
          let Currency = state.state.payment_data.Currency != '' ? state.state.payment_data.Currency : ''
          let token = (state.state.user_data.data.token||state.state.user_token) + '-' + state.state.site_id
          state.commit('setPayment', { MerchantID, ClientId, FirstName, LastName, DestinationTag, BillingID, Email, Currency, token, Test: false })
        }
        if (state.state.skins[0].auto_payment.providers[1].name == '88pay' && state.state.skins[0].auto_payment.providers[1].enabled) {
          let data = {
            user: state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id + '_' + state.state.user_data.data.token + "_" + state.state.apiHostnew,
            country: state.state.user_data.data.country ?? '',
            amount: 0.0,
            email: state.state.user_data.data.email,
            description: 'DEPOSIT',
            customer: {
              name: ''
            },
            paymentMethod: "",
            cpf: "",
            address: {
              line1: "",
              line2: "",
              postalCode: ""
            },
            currency: state.state.user_data.data.currency,
            cardNumber: "",
            cardMonth: "",
            cardYear: "",
            cardCVV: "",
            token:(state.state.user_data.data.token||state.state.user_token) + '-' + state.state.site_id,
            domain: state.state.apiHostnew,
            url: `https://${domain.split('//')[1].split('admin.')[1]}/`
          }
          state.commit('set88pay', data)
        }
        if(state.state.skins[0].auto_payment.providers[2].provider == 'betterpro' && state.state.skins[0].auto_payment.providers[2].enabled){
          // console.log(state.state.user_data,state.state.user_token)
          let data = {
            locale:state.state.language,
            external_customer_id:state.state.user_data.data.user_id+'_'+ state.state.skins[0].register_fields.root +'_'+state.state.site_id,
            currency: "BRL",
            amount:0.0,
            fields:{},
            token:(state.state.user_data.data.token||state.state.user_token) + '-' + state.state.site_id,
            domain:state.state.apiHostnew,
            url:state.state.apiHostnew
          }
          state.commit('setPixpay', data)
        }
        if (state.state.skins[0].auto_payment.providers[3].name == 'QuicklyPay' && state.state.skins[0].auto_payment.providers[3].enabled) {
          let banks = await axios.get('https://payment-proxy.jbets.online/api/quicklypay/bank')
          state.commit('setQuicklyPayBanks', banks.data)
          console.log(state.state.user_data.data?.token || state.state.user_token)
          let data = {
            user: state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id + '_' + (state.state.user_data.data?.token || state.state.user_token) + "_" + state.state.apiHostnew,
            moneda: 'COP',
            valor: 0.0,
            usuDoc: '',
            usuTipdoc: '',
            usuNombre: '',
            usuTelefono: '',
            token: state.state.user_data.data?.token || state.state.user_token,
            usuCorreo: '',
            domain: state.state.apiHostnew,
            link: state.state.apiHostnew
          }
          state.commit('setQuicklyPay', data)
        }
        if(state.state.skins[0].auto_payment.providers[4].name == 'ArgQuartz' && state.state.skins[0].auto_payment.providers[4].enabled){
          console.log(state.state.user_data,state.state.user_token,state.state.skins[0].auto_payment.providers)
          let data = {
            external_customer_id:state.state.user_data.data.user_id+'_1246_'+state.state.site_id,
            fiatCurrency: "EUR",
            "lineItems": [
              {
                "quantity": 1,
                "price": 0.0,
                "name": "test",
                "description": "recarga"
              }
            ],
            timeout:1000,
            totalPrice:0.0,
            kyc:{},
            token:state.state.user_data.data.token||state.state.user_token,
            domain:state.state.apiHostnew,
          }
          state.commit('setCriptopay', data)
        }
      }
    },
    async setPayment2(state) {
      if (state.state.skins[0].auto_payment) {
        if (state.state.skins[0].auto_payment.providers[0].name == '0xProcessing' && state.state.skins[0].auto_payment.providers[0].enabled) {
          // console.log(state.state.user_data.data)
          let ClientId = state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id
          let FirstName = state.state.user_data.data.user_name
          let LastName = ''
          let DestinationTag = ''
          let BillingID = state.state.user_data.data.user_id + '_' + state.state.site_id
          let MerchantID = "0xMR2835196"
          let Email = state.state.user_data.data.email
          let Currency = state.state.payment_data_rate.Currency != '' ? state.state.payment_data_rate.Currency : ''
          let token = state.state.user_data.data.token
          state.commit('setPayment2', { MerchantID, ClientId, FirstName, LastName, DestinationTag, BillingID, Email, Currency, token, Test: false })
        }
      }
    },
    async setWithdraw(state) {
      let domain = state.state.domain
      if (state.state.skins[0].auto_payment) {
        if (state.state.skins[0].auto_payment.providers[0].name == '0xProcessing' && state.state.skins[0].auto_payment.providers[0].enabled) {
          // console.log(state.state.user_data.data)
          let ClientId = state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id
          let Amount = 0.0
          let Address = ''
          let DestinationTag = ''
          let ExternalId = state.state.user_data.data.user_id + '_' + state.state.site_id
          let Currency = state.state.withdraw_data.Currency != '' ? state.state.payment_data.Currency : ''
          let token = state.state.user_data.data.token
          state.commit('setWithdraw', { ClientId, ExternalId, Currency, DestinationTag, Amount, Address, token, Test: false })
        }
        if (state.state.skins[0].auto_payment.providers[2].provider == 'betterpro' && state.state.skins[0].auto_payment.providers[2].enabled) {
          // console.log(state.state.user_data.data)
          let data = {
            locale:state.state.language,
            external_customer_id:state.state.user_data.data.user_id+'_'+ state.state.skins[0].register_fields.root +'_'+state.state.site_id,
            currency: "BRL",
            amount:0.0,
            fields:{},
            token:(state.state.user_data.data.token||state.state.user_token) + '-' + state.state.site_id,
            url:state.state.apiHostnew,
          }
          state.commit('setWithdrawPix', data)
        }
        if (state.state.skins[0].auto_payment.providers[3].name == 'QuicklyPay' && state.state.skins[0].auto_payment.providers[3].enabled) {
          let banks = await axios.get('https://payment-proxy.jbets.online/api/quicklypay/bank')
          state.commit('setQuicklyPayBanks', banks.data)
          // console.log(banks)
          let data = {
            user: state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id + '_' + (state.state.user_data.data?.token || state.state.user_token) + "_" + state.state.apiHostnew,
            moneda: 'COP',
            valor: 0.0,
            usuDoc: '',
            usuTipdoc: '',
            usuNombre: '',
            usuTelefono: '',
            token: state.state.user_data.data?.token || state.state.user_token,
            usuCorreo: '',
            numCuenta: '',
            domain: state.state.apiHostnew,
            tipoCuenta: '',
            link: `https://${domain.split('//')[1].split('admin.')[1]}/`
          }
          state.commit('setQuicklyPayOut', data)
        }
        if(state.state.skins[0].auto_payment.providers[4].name == 'ArgQuartz' && state.state.skins[0].auto_payment.providers[4].enabled){
          console.log(state.state.user_data,state.state.user_token,state.state.skins[0].auto_payment.providers)
          let data = {
            external_customer_id:state.state.user_data.data.user_id+'_'+ state.state.user_data.data.parent +'_'+state.state.site_id,
            "amount": 0.00,
            "country": "ARGENTINA",
            "currency": "ARS",
            "destinationAccount": {
                "country": "ARGENTINA",
                "currency": "ARS",
                "destinationType": {
                }
            },
            token:state.state.user_data.data.token||state.state.user_token,
            domain:state.state.apiHostnew,
          }
          state.commit('setCriptopayOut', data)
        }
      }
    },
    async get88Payment(state) {
      let data = state.state.payment_88pay
      const url = state.state.apiHostnew;
      // console.log(url + "payment88",data)
      // return
      try {
        const response = await axios.post(url + "payment88", data);
        if (response.data) {
          state.commit("get88Payment", response.data)
          window.location.href = response.data.data.url;
        }
      } catch (error) {
        state.commit("getPayment", { error: 'Error: Review the data you entered or try again later' })
        console.log(error)

      }

    },
    async getPixPayment(state) {
      let data = {}
      data.data = state.state.payment_pixpay
      data.userId=state.state.skins[0].auto_payment.providers[2].userId
      data.resellerId=state.state.skins[0].auto_payment.providers[2].resellerId
      data.playerId = state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id
      data.playerName = state.state.user_data.data.user_name || state.state.user_data.data.username
      data.provider = 'betterpro'
      data.action = "recarga"
      const url = state.state.apiHostnew;
      // console.log(url + "payment88",data)
      // return
      try {
        const response = await axios.post(url + "external_payment", data);
        if (response.data) {
          state.commit("getPixPayment", response.data)
          // console.log(response.data)
          if (!response.data.success) {
            state.commit("getPayment", { error: response.data.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
            return
          }
          window.location.href = response.data.data.response?.result.pay_url;

        }
      } catch (error) {
        state.commit("getPayment", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)
      }
    },
    async getCriptoPayment(state) {
      let data = {}
      data.data = state.state.payment_criptopay
      data.provider = 'argquartz'
      data.platform = 'surmar'
      data.user = 1234
      data.playerId = 12134
      data.action = "recarga"
      const url = state.state.apiHostnew;
      console.log(url,data)
      // return
      try {
        const response = await axios.post(url + "external_payment", data);
        if (response.data) {
          state.commit("getPixPayment", response.data)
          // console.log(response.data)
          if (!response.data.success) {
            state.commit("getPayment", { error: response.data.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
            return
          }
          window.location.href = response.data.data.redirectURL;

        }
      } catch (error) {
        state.commit("getPayment", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)
      }
    },
    async getQuicklyPayment(state) {
      let data = state.state.payment_quicklypay
      const url = state.state.apiHostnew;
      console.log(url + "payment", data)
      // return
      try {
        const response = await axios.post(url + "paymentQuicklyPay", data);
        if (response.data) {
          state.commit("getQuicklyPayment", response.data)
          // console.log(response.data)
          if (!response.data.success) {
            state.commit("getPayment", { error: response.data.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
            return
          }
          if (response.data.data?.data?.checkout) {
            window.location.href = response.data.data?.data?.checkout;
          }
        }
      } catch (error) {
        state.commit("getPayment", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)
      }
    },
    async getPayment(state) {
      let data = state.state.payment_data
      const url = state.state.apiHostnew;
      try {
        const response = await axios.post(url + "payment", data);
        if (response.data) {
          state.commit("getPayment", response.data)
        }
      } catch (error) {
        state.commit("getPayment", { error: 'Error: Review the data you entered or try again later' })
        console.log(error)

      }

    },
    async getPayment2(state) {
      let data = state.state.payment_data_rate
      const url = state.state.apiHostnew;
      try {
        const response = await axios.post(url + "payment", data);
        if (response.data) {
          state.commit("getPayment2", response.data)
        }
      } catch (error) {
        state.commit("getPayment2", { error: 'Error: Review the data you entered or try again later' })
        console.log(error)
      }

    },
    async getWithdraw(state) {
      let data = state.state.withdraw_data
      let balance = state.state.user_data.data.balance
      data.balance = balance
      // console.log(state.state.user_data.data)
      const url = state.state.apiHostnew;
      // let rate = state.state.payment_form_rate.paymentData.rate
      let amount = state.state.withdraw_data.AmountUSD
      // data.amountUSD = parseFloat(amount)
      // console.log(state.state.payment_form)
      // console.log("valor: ",parseFloat(amount))
      let data2 = {
        user: state.state.user_data.data.user_id,
        site: state.state.site_id,
        login_Id: state.state.user_data.data.parent,
        token: state.state.user_data.data.token,
        capital: parseFloat(amount),
        type: 'Automática'
      }
      let response
      // let response2
      try {
        if (balance < parseFloat(amount)) {
          state.commit("getWithdraw", { error: 'Error: Review the data you entered or try again later' })

        } else {
          // console.log(data,data2)
          response = await axios.post(url + "withdraw", { data, data2 });
          // console.log(response.data)
          if (response.data) {
            state.commit("getWithdraw", { error: 'Retirada em andamento, pode levar alguns minutos, aguarde a atualização do seu saldo.' })
          }
        }

        //   response2 = await axios.post(url+"retirarcapitaljugador",data2)
        // if(response2.data.status=="success"){
        // }else{
        //   state.commit("getWithdraw",{error:'Error: Review the data you entered or try again later'})
        // }
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);

      } catch (error) {
        state.commit("getWithdraw", { error: 'Error: Review the data you entered or try again later' })
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);
        console.log(error)

      }
    },
    async getPixWithdraw(state) {
      let data = {}
      let balance = state.state.user_data.data.balance
      // data.balance = balance
      data.data = state.state.withdraw_data_pix
      data.userId=state.state.skins[0].auto_payment.providers[2].userId
      data.resellerId=state.state.skins[0].auto_payment.providers[2].resellerId
      data.playerId = state.state.user_data.data.user_id + '_' + state.state.skins[0].register_fields.root + '_' + state.state.site_id
      data.playerName = state.state.user_data.data.user_name || state.state.user_data.data.username
      data.provider = 'betterpro'
      data.action = "retiro"
      // console.log(state.state.user_data.data)
      const url = state.state.apiHostnew;
      // let rate = state.state.payment_form_rate.paymentData.rate
      let amount = state.state.withdraw_data_pix.amount
      // data.amountUSD = parseFloat(amount)
      // console.log(state.state.payment_form)
      // console.log("valor: ",parseFloat(amount))
      let data2 = {
        user: state.state.user_data.data.user_id,
        site: state.state.site_id,
        login_Id: state.state.skins[0].register_fields.root,
        token:  state.state.user_data.data?.token || state.state.user_token,
        capital: parseFloat(amount),
        type: 'Automática'
      }
      let response
      // let response2
      try {
        if (balance < parseFloat(amount)) {
          state.commit("getWithdraw", { error: 'Error: Review the data you entered or try again later' })

        } else {
          // console.log(data,data2)
          response = await axios.post(url + "external_payment", data);
          // console.log(response.data)
          if (response.data) {
            if (response.data.details && response.data.details.error && response.data.details.error.code != 0) {
              // console.log(response.data.details?.error?.title??'Withdrawal in process, please wait')
              state.commit("getWithdraw", { error: response.data.details.error.title +' Contact Support' })
            } else {
              state.commit("getWithdraw", { error: 'Retirada em andamento, pode levar alguns minutos, aguarde a atualização do seu saldo.' })
            }
            // console.log(response.data.details?.error?.title??'Withdrawal in process, please wait')
          }
        }
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);

        //   response2 = await axios.post(url+"retirarcapitaljugador",data2)
        // if(response2.data.status=="success"){
        // }else{
        //   state.commit("getWithdraw",{error:'Error: Review the data you entered or try again later'})
        // }

      } catch (error) {
        // console.log(response,error.response)
        state.commit("getWithdraw", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);
      }
    },
    async getCriptoWD(state) {
      let data = state.state.withdraw_criptopay
      let balance = state.state.user_data.data.balance
      // data.balance = balance
      // console.log(state.state.user_data.data)
      const url = state.state.apiHostnew;
      // let rate = state.state.payment_form_rate.paymentData.rate
      let amount = state.state.withdraw_criptopay.amount
      // data.amountUSD = parseFloat(amount)
      // console.log(state.state.payment_form)
      // console.log("valor: ",parseFloat(amount))
      let data2 = {
        user: state.state.user_data.data.user_id,
        site: state.state.site_id,
        login_Id: state.state.skins[0].register_fields.root,
        token:  state.state.user_data.data?.token || state.state.user_token,
        capital: parseFloat(amount),
        type: 'Automática'
      }
      let response
      // let response2
      try {
        if (balance < parseFloat(amount)) {
          state.commit("getWithdraw", { error: 'Error: Review the data you entered or try again later' })

        } else {
          console.log(data,data2)
          // return
          response = await axios.post(url + "external_withdraw", { data, data2 });
          // console.log(response.data)
          if (response.data) {
            // console.log(response.data.details?.error?.title??'Withdrawal in process, please wait')
            state.commit("getWithdraw", { error: 'Retirada em andamento, pode levar alguns minutos, aguarde a atualização do seu saldo.' })
          }
        }
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);

        //   response2 = await axios.post(url+"retirarcapitaljugador",data2)
        // if(response2.data.status=="success"){
        // }else{
        //   state.commit("getWithdraw",{error:'Error: Review the data you entered or try again later'})
        // }

      } catch (error) {
        // console.log(response,error.response)
        state.commit("getWithdraw", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)
        setTimeout(() => {
          state.commit("getWithdraw", { error: '' })

        }, 10000);
      }
    },
    async getQuicklyWD(state) {
      let data = state.state.payment_quicklypayout
      let balance = state.state.user_data.data.balance
      data.balance = balance
      // console.log(state.state.user_data.data)
      const url = state.state.apiHostnew;
      // let rate = state.state.payment_form_rate.paymentData.rate
      let amount = state.state.payment_quicklypayout.valor
      // data.amountUSD = parseFloat(amount)
      // console.log(state.state.payment_form)
      // console.log("valor: ",parseFloat(amount))
      let data2 = {
        user: state.state.user_data.data.user_id,
        site: state.state.site_id,
        login_Id: state.state.skins[0].register_fields.root,
        token: state.state.user_data.data?.token || state.state.user_token,
        capital: parseFloat(amount),
        type: 'Automática'
      }
      let response
      // console.log({data,data2})
      // return
      // let response2
      try {
        if (balance < parseFloat(amount)) {
          state.commit("getWithdraw", { error: 'Error: Review the data you entered or try again later' })

        } else {
          // console.log(data,data2)
          response = await axios.post(url + "withdrawQuicklyPay", { data, data2 });
          // console.log(response.data)
          if (response.data) {
            // console.log(response.data.details?.error?.title??'Withdrawal in process, please wait')
            state.commit("getWithdraw", { error: response.data.details?.error?.title ?? 'Withdrawal in process, please wait' })
          }
        }

        //   response2 = await axios.post(url+"retirarcapitaljugador",data2)
        // if(response2.data.status=="success"){
        // }else{
        //   state.commit("getWithdraw",{error:'Error: Review the data you entered or try again later'})
        // }

      } catch (error) {
        // console.log(response,error.response)
        state.commit("getWithdraw", { error: error.response.data.message.details?.error?.title ?? 'Error: Review the data you entered or try again later' })
        console.log(error)

      }
    },
    async getSkin(state) {
      try {
        // state.dispatch("getWidget",state)

        let formated = router.currentRoute.query.target;
        if (formated !== "") {
          state.commit('setHostName', formated);
          let site_id = formated.split("-")[0] + "-" + formated.split("-")[1];
          const response = await axios.get(process.env.VUE_APP_DATA_SERVER + "get_skin?site_id=" + site_id);
          let qtag = router.currentRoute.query.qtag ?? '';
          let datalogin = router.currentRoute.query.data ?? '';
          if (response.data.length > 0) {
            if (response.data[0].prematch != null) {
              if (!response.data[0].prematch) {
                router.push({ name: 'LiveMainEcuabets' })
              }
            }
            state.dispatch("setToken");
            state.commit("setMainView", response.data);
            if (response.data[0]) {
              let view = response.data[0]?.start_page || 'lobby';
              await state.dispatch('changeView', view);
              state.commit("set_urls")
            }
            if(datalogin != ''){
              let partes = datalogin.split(':');
              console.log(partes)
              await state.dispatch('login', {username:partes[0],password:partes[1]});
            }

            if ((qtag != '') ) {
              state.commit("setQtag", qtag)
            } else {
              localStorage.removeItem("qtag");
            }
          }
          const response2 = await axios.get(process.env.VUE_APP_DATA_SERVER + "get_translations");
          state.commit("setTranslations", response2.data);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getAffiliate(state, payload) {
      try {
        // console.log(payload);
        // Asegurarse de que 'qtag' sea siempre una cadena sin comillas adicionales
        // let qtag = payload;
        // if (typeof qtag === "string" && qtag.startsWith('"') && qtag.endsWith('"')) {
        //   qtag = JSON.parse(qtag); // Elimina las comillas adicionales si se guardaron como JSON en localStorage
        // }
        // const response = await axios.get(url + "check_afiliado", { params: { qtag: qtag.toString() } });
        const url = state.state.apiHostnew;
        const response = await axios.get(url + "informacion", { params: { users: payload, login_Id: payload, token: 'qCpxTbvkZBePznR', site: state.state.site_id } });
        // console.log(response.data)
        // if (response.data) {
        //   state.commit('setRoot', response.data)
        // }
        if (response.data.error) {
          console.log(response.data);
          // localStorage.removeItem("qtag");
          // state.commit("setQtag", '');
          state.dispatch('getPanel')
        } else {
          state.commit("setAfiliado", response.data);
          localStorage.setItem("qtag", JSON.stringify(response.data.affiliate_id));
          const qtagFromCookie = await state.dispatch('getCookie', 'qtag');
          // console.log('Qtag from Cookie:', qtagFromCookie,payload);
          if (qtagFromCookie != payload) {
            state.dispatch('deleteCookie', 'qtag');
          }
        }
      } catch (error) {
        return [];
      }
    },
    async deleteCookie(_, name) {
      // Establecer la cookie con una fecha de expiración en el pasado para eliminarla
      document.cookie = `${name}=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC;`;
    },
    async storeQtag(state, payload) {
      document.cookie = `qtag=${payload}; path=/; max-age=31536000`; // Caducidad de 1 día (86400 segundos)
      const qtag = await state.dispatch('getCookie', 'qtag');
      // console.log('Qtag Cookie:', qtag);
    },
    async getCookie(_, name) {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) return parts.pop().split(';').shift();
      return null; // Devuelve null si no encuentra la cookie
    },
    async setLobbyView(state, payload) {
      await state.commit("setLobbyView", payload)
    },
    async login(state, payload) {
      try {
        // console.log(state.state.domain)
        const response = await axios.get(
          state.state.domain + '/oauth/v2/token?username=' + payload.username + '&password=' + payload.password + '&client_id=1_5i50wo24kpcscc0okw0ww4gsc8kwg0k8gs0ok44skooww4swcg&client_secret=18qxs6584gw08scg8wsk8gow44oc4gcw40c4o8w44880g0gkcg&grant_type=password');
        let site = "";
        let site_id = state.state.site_id;
        let token = response.data.access_token;
        let prefix = "api";
        site = "jugar";
        let router_data = {
          token: token,
          site_id: site_id,
          site: site,
          prefix: prefix,
          type: "login"
        }
        state.commit("setToken", router_data);
        state.commit("setWidget", true);
        if (state.state.skins[0].skin_type !== 'altenar') {
          await state.dispatch("getProfile", router_data);
        }
        else {
          console.log('acá3')
          await state.dispatch("getUserData", router_data);
        }
        state.commit("set_urls")
        state.dispatch("setRechargeIframe")
        return "success";
      } catch (error) {
        localStorage.setItem('errorlogin', error);
        localStorage.removeItem("user_data");
        return error.response.data.error_description || 'Usuario o clave invalidos! Intenta nuevamente.';
      }
    },
    async login_demo(state, payload) {
      try {
        // console.log(state.state.domain)
        const response = await axios.get(
          state.state.domain + '/oauth/v2/token?username=' + payload.username + '&password=' + payload.password + '&client_id=1_5i50wo24kpcscc0okw0ww4gsc8kwg0k8gs0ok44skooww4swcg&client_secret=18qxs6584gw08scg8wsk8gow44oc4gcw40c4o8w44880g0gkcg&grant_type=password');
        let site = "";
        let site_id = state.state.site_id;
        let token = response.data.access_token;
        let prefix = "api";
        site = "jugar";
        let router_data = {
          token: token,
          site_id: site_id,
          site: site,
          prefix: prefix,
          type: "login"
        }
        state.commit("setToken2", router_data);
        console.log(state.state.skins[0].skin_type, state.state.site_id)
        if (state.state.skins[0].skin_type !== 'altenar') {
          state.dispatch("getProfile2", router_data);
        }
        else {
          console.log('acá1')
          state.dispatch("getUserData", router_data);
        }
        // state.dispatch("setRechargeIframe")
        return "success";
      } catch (error) {
        console.log(error);
        return 'Usuario o clave invalidos! Intenta nuevamente.';
      }
    },
    async getAuditoria(state, payload) {
      try {
        let data = await axios.get(localStorage.getItem('setApiHostnew') + "auditoria", {
          params: {
            "login_Id": payload.data.data.user_id ?? payload.data.data.id,
            "token": state.state.user_token,
          }
        })
        if (data.data[0].descripcion == "Agente cambio su clave") {
          state.commit("setShowChangePassword", true);
        }
        state.commit("setAuditoria", data.data[1]);
        return data.data
      } catch (error) {
        return []
      }
    },
    async logOut(state) {
      state.commit("logOut");
      let view = state.state.skins[0]?.start_page || "lobby";
      state.dispatch("changeView", view);
      localStorage.removeItem("user_data");
      state.dispatch("setRechargeIframe")
    },
    updateJivoElements(state, payload) {
      state.commit('SET_JIVO_ELEMENT1', payload);
    }
  },
  getters: {
    getInfoRouter: state => state.infoRouter,
    getQuicklyPayBanks: state => state.colBanks,
    getConfig: state => state.config,
    getCoin_info: state => state.coin_info,
    getCoin_info2: state => state.coin_info2,
    getQtag: state => state.qtag,
    getPayment: state => state.payment_form,
    getPayment2: state => state.payment_form_rate,
    getPaymentData: state => state.payment_data,
    getPaymentData2: state => state.payment_data_rate,
    getWithdrawData: state => state.withdraw_data,
    getWithdraw: state => state.withdraw_form,
    getSite: state => state.site_id,
    getApiUrlnew: state => state.apiHostnew,
    getSite: state => state.site_id,
    jivoElement1: state => state.jivoElement1,
    getAfiliado: state => state.afiliado,
    getRoot: state => state.root,
    getRoot2: state => state.root2,
    getModalFlag: state => state.jivo_modal_flag,
    getAuditoria: state => state.auditoria,
    getMisdatos: state => state.mis_datos,
    getrechargeIframe: state => state.rechargeIframe,
    getMessage: state => state.message_recived,
    getActualRoute: state => state.actualRoute,
    getShowChangePassword: state => state.showChangePassword,
    getHeaderHeight: state => state.headerHeight,
    getCurrency: state => state.currency,
    getCurrentSkin: state => state.skins[state.currentSkin],
    getSkinCharged: state => state.skin_charged,
    getHostName: state => state.hostName,
    getLanguage: state => state.language,
    getTranslation: state => state.translation,
    getToken: state => state.user_token,
    getDomain: state => state.domain,
    getSiteId: state => state.site_id,
    getUserData: state => {
      return {
        token: state.user_token,
        site_id: state.site_id,
        domain: state.domain,
        site: state.site,
        prefix: state.prefix,
        user_data: state.user_data,
        vivoOperatorId: state.config.SkinCConfig.vivoOperatorId,
        vivoServerId: state.config.SkinCConfig.vivoServerId,
      }
    },
    getUserDataDemo: state => {
      return {
        token: state.user_token_demo,
        site_id: state.site_id,
        domain: state.domain,
        site: state.site,
        prefix: state.prefix,
        user_data: state.user_data_demo,
        vivoOperatorId: state.config.SkinCConfig.vivoOperatorId,
        vivoServerId: state.config.SkinCConfig.vivoServerId,
      }
    },
    getView: state => state.view,
    getHomeButton: state => state.home_button,
    getLobbyView: state => state.lobby_view,
    getRechargeIframe: state => state.rechargeIframe,
  }
})
